import { ID_CAPTCHA, USER_ENTERED_CAPTCHA_CODE, LOCALIZADOR, DOCUMENTO } from 'utils/consts';

export const descricaoProtocolo =
  'Informe CPF ou CNPJ cadastrado no requerimento, e o Número de Protocolo enviado no email para consultar o requerimento.';

export const successSubmit = (localizador, documento) => {
  localStorage.setItem(LOCALIZADOR, localizador);
  localStorage.setItem(DOCUMENTO, documento);
  localStorage.setItem(ID_CAPTCHA, '');
  localStorage.setItem(USER_ENTERED_CAPTCHA_CODE, '');
};

export const finallySubmit = () => {
  localStorage.removeItem(LOCALIZADOR);
  localStorage.removeItem(DOCUMENTO);
  localStorage.removeItem(ID_CAPTCHA);
  localStorage.removeItem(USER_ENTERED_CAPTCHA_CODE);
};
